import React, { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import AnimatedNumber from './AnimatedNumber'
import { useCart } from './CartContext'
import { useNotification } from './NotificationContext'
import { useNavigate } from 'react-router-dom'
import './ProductCard.css'

function ProductCard({ cookie }) {
  const [quantity, setQuantity] = useState(1);
  const [isHovered, setIsHovered] = useState(false);
  const { addToCart, cart } = useCart();
  const { showNotification } = useNotification();
  const navigate = useNavigate();

  console.log("Cookie", cookie)
  
  const handleIncrement = () => {
    setQuantity(prev => prev + 1);
  };

  const handleDecrement = () => {
    if (quantity > 1) {
      setQuantity(prev => prev - 1);
    }
  };

  const handleAddToCart = (e) => {
    e.stopPropagation(); // Prevent navigation when clicking add to cart
    console.log('Before addToCart - Current cart:', cart);
    console.log('Adding product:', cookie, 'Quantity:', quantity); 
    
    // Create product object with variant information
    const productForCart = {
      id: cookie.id,
      name: cookie.name,
      price: cookie.price,
      image: cookie.image,
      variant: cookie.weight || 'Standard', // Use weight as variant, fallback to 'Standard'
      variantPrice: cookie.price, // Store the variant-specific price
      ingredients: cookie.ingredients,
      issoldout: cookie.issoldout
    };
    
    addToCart(productForCart, quantity);
    showNotification(`${cookie.name} (${cookie.weight || 'Standard'}) added to cart!`);
    setQuantity(1); 
    
    setTimeout(() => {
      console.log('After addToCart - Cart should be updated'); 
    }, 100);
  };

  const handleCardClick = () => {
    navigate(`/product/${cookie.id}`);
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1
      }
    },
    exit: {
      opacity: 0,
      transition: {
        staggerChildren: 0.05,
        staggerDirection: -1
      }
    }
  };

  const ingredientVariants = {
    hidden: {
      scale: 0,
      opacity: 0,
      y: 0,
      x: 0,
      rotate: 0
    },
    visible: (index) => ({
      scale: 1,
      opacity: 1,
      y: index === 0 ? -100 : index === 1 ? -80 : 50, 
      x: index === 0 ? -100 : index === 1 ? 100 : 0, 
      rotate: index === 0 ? -12 : index === 1 ? 12 : -6, 
      transition: {
        type: "spring",
        damping: 15,
        stiffness: 300,
        delay: index * 0.1
      }
    }),
    exit: {
      scale: 0,
      opacity: 0,
      y: 0,
      x: 0,
      rotate: 0,
      transition: {
        type: "spring",
        damping: 20,
        stiffness: 400,
        duration: 0.3
      }
    }
  };

  return (
    <div
      className='productCard'
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{ cursor: 'pointer' }}
    >
      <img src='/footerlogo.PNG' alt='' className='cardClip' />
      <div className='cookieImageContainer'>
        <div className='cookieImage'>
          <img
            src={cookie.image || '/images.png'}
            alt={cookie.name}
            className='cookieImg'
            onError={(e) => { e.target.src = '/images.png'; }}
            onClick={handleCardClick}
          />
          
          <div className='ingredientsContainer'>
            <AnimatePresence>
              {isHovered && (
                <motion.div
                  className='ingredientsList'
                  variants={containerVariants}
                  initial="hidden"
                  animate="visible"
                  exit="exit"
                >
                  {cookie.ingredients && cookie.ingredients.map((ingredient, index) => (
                    <motion.span
                      key={ingredient}
                      className='ingredient'
                      custom={index}
                      variants={ingredientVariants}
                    >
                      {ingredient}
                    </motion.span>
                  ))}
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </div>
      </div>

      <div className='productInfo'>
        <div onClick={handleCardClick} className='productContent'>
          <p className='cookieName'>{cookie.name}</p>
          {cookie.tagline && <p className='cookieTagline'>{cookie.tagline}</p>}
          <p className='cookieDescription'>{cookie.description}</p>
          <p className='cookieDetails'>{cookie.weight || 'Standard Size'}</p>
        </div>
        
        <div className='productFooter'>
          <div className='priceAndQuantity'>
            <span className='price'>£{typeof cookie.price === 'number' ? cookie.price.toFixed(2) : cookie.price}</span>
            <div className='quantityControls'>
              <button
                className='quantityBtn decrease'
                onClick={handleDecrement}
                disabled={quantity === 1}
              >
                −
              </button>
              <AnimatedNumber value={quantity} />
              <button
                className='quantityBtn increase'
                onClick={handleIncrement}
              >
                +
              </button>
            </div>
          </div>
          
          <button 
            disabled={cookie.issoldout} 
            className='addToCartBtn' 
            onClick={handleAddToCart}
          >
            {cookie.issoldout ? 'SOLD OUT' : 'ADD TO CART'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ProductCard
